import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { InfoIcon } from "lucide-react";
import { otherPlacements, placements } from "../data/placements";
export function Placements() {
  const [activeId, setActiveId] = useState(placements[0].id);
  const active = placements.find(p => p.id === activeId) ?? placements[0];
  return <section id="placements" className="w-full bg-cream py-24 lg:py-32" data-id="element-158" data-mp="2zbqcx1x2r3xf">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-159" data-mp="vfgr4mkfg8y">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-160" data-mp="3s1p9rjhig5cn">
          <div className="lg:col-span-7" data-id="element-161" data-mp="3s0e4tgcbwrjy">
            <h2 className="font-serif text-4xl font-medium text-ink lg:text-5xl" data-id="element-162" data-mp="3n2clqvewks8h">Placements financiers</h2>
            <p className="mt-4 max-w-xl text-lg text-muted" data-id="element-163" data-mp="3i313tj2svgpb">
              Des placements adéquats selon votre situation et vos besoins.
            </p>
          </div>
          <div className="lg:col-span-5" data-id="element-164" data-mp="26p5lk1glmrtv">
            <p className="text-sm text-muted" data-id="element-165" data-mp="26o485qc41t8z">Également disponibles</p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-166" data-mp="20z3vyu4iyf1d">
              {otherPlacements.map(p => <li key={p} className="rounded-full border border-line bg-white px-4 py-1.5 text-sm text-ink" data-id="element-167" data-mp="25yq8t2gfxt9n">
                  {p}
                </li>)}
            </ul>
          </div>
        </div>

        <div role="tablist" aria-label="Types de placement" className="mt-14 flex gap-2 overflow-x-auto border-b border-line" data-id="element-168" data-mp="1vz91kgljj7bk">
          {placements.map(p => {
          const isActive = p.id === activeId;
          return <button key={p.id} type="button" role="tab" aria-selected={isActive} aria-controls="placement-panel" onClick={() => setActiveId(p.id)} className={`relative whitespace-nowrap px-4 pb-4 pt-2 text-base font-medium transition-colors duration-150 ${isActive ? "text-ink" : "text-muted hover:text-ink"}`} data-id="element-169" data-mp="1n1p31ff2bp4n">
                {p.name}
                {isActive && <motion.span layoutId="placement-underline" className="absolute inset-x-0 -bottom-px h-0.5 bg-brand" transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-170" data-mp="3171z21brbgs5" />}
              </button>;
        })}
        </div>

        <div id="placement-panel" role="tabpanel" className="mt-12" data-id="element-171" data-mp="3ovth3zvmuir7">
          <AnimatePresence mode="wait" data-id="element-172" data-mp="3jxs1joxf11kh">
            <motion.div key={active.id} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-12 lg:grid-cols-12" data-id="element-173" data-mp="3jyuqhrb6gtxr">
              <div className="lg:col-span-5" data-id="element-174" data-mp="23hgs3j6shf8c">
                <h3 className="font-serif text-3xl font-medium text-ink" data-id="element-175" data-mp="1zh5725ailcwc">{active.name}</h3>
                <p className="mt-5 text-lg leading-relaxed text-muted" data-id="element-176" data-mp="f0yskwuqspvz">{active.summary}</p>
                {active.note && <p className="mt-8 flex gap-3 rounded-xl bg-white p-4 text-sm leading-relaxed text-muted" data-id="element-177" data-mp="j2ajd5pcrh5r">
                    <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" data-id="element-178" data-mp="nzj33aq5ft94" />
                    {active.note}
                  </p>}
              </div>
              <div className="lg:col-span-6 lg:col-start-7" data-id="element-179" data-mp="xplw3ax9t77g">
                <h4 className="text-sm font-semibold text-ink" data-id="element-180" data-mp="12pqbsyqctxwm">{active.detailTitle}</h4>
                <dl className="mt-4 divide-y divide-line border-y border-line" data-id="element-181" data-mp="12rl08n0u485g">
                  {active.details.map(d => <div key={d.label} className="grid gap-1 py-5 sm:grid-cols-[180px_1fr] sm:gap-6" data-id="element-182" data-mp="1bqy9pfoykwq6">
                      <dt className="font-medium text-ink" data-id="element-183" data-mp="38jhys5o631iw">{d.label}</dt>
                      <dd className="text-muted" data-id="element-184" data-mp="3dhta6ku41k38">{d.text}</dd>
                    </div>)}
                </dl>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}